@import "./../../less/variables.less";

.oppsummering {
  background: var(--dds-card-bg-accent);
  padding: var(--dds-spacing-medium-24);
  border-radius: var(--dds-radius-medium);
  display: flex;
  flex-direction: column;
  gap: var(--dds-spacing-medium-24);
}

.oppsummering > article {
  display: flex;
  flex-direction: column;
}

.miniheader {
  margin: 0;
  font-weight: 500;
}

.acceptTermsContainer {
  margin-top: var(--dds-spacing-small-12);
}
